export const SG_COUNTRY_ID = 192;
export const HK_COUNTRY_ID = 96;
export const ID_COUNTRY_ID = 100;
export const PH_COUNTRY_ID = 169;

